if (!customElements.get('collapsible-description')) {
	customElements.define(
		'collapsible-description',
		class CollapsibleDescription extends HTMLElement {
			connectedCallback() {
				this.content = this.querySelector('.product__description')
				this.toggle = this.querySelector('.product__description-toggle')
				if (!this.content || !this.toggle) return

				if (!this.initialized) {
					this.initialized = true
					this.toggle.addEventListener('click', this.onToggle.bind(this))
				}

				this.checkHeight()
				// images in the description can change its height after load
				window.addEventListener('load', () => this.checkHeight(), {
					once: true,
				})
			}

			// hides the toggle when the description already fits the collapsed height
			checkHeight() {
				if (this.classList.contains('is-expanded')) return
				this.classList.toggle(
					'is-short',
					this.content.scrollHeight <= this.content.clientHeight + 1
				)
			}

			onToggle() {
				if (this.classList.contains('is-expanded')) {
					this.collapse()
				} else {
					this.expand()
				}
			}

			expand() {
				// pin the current (collapsed) height as an explicit start value so
				// the following frame's change to the full height is animated
				this.content.style.maxHeight = `${this.content.clientHeight}px`
				this.classList.add('is-expanded')
				this.toggle.setAttribute('aria-expanded', 'true')

				const target = this.content.scrollHeight
				requestAnimationFrame(() => {
					this.content.style.maxHeight = `${target}px`
				})

				// once open, let the description grow freely (e.g. late-loading images)
				this.content.addEventListener('transitionend', this.onExpandEnd, {
					once: true,
				})
			}

			onExpandEnd = (event) => {
				if (
					event.propertyName === 'max-height' &&
					this.classList.contains('is-expanded')
				) {
					this.content.style.maxHeight = 'none'
				}
			}

			collapse() {
				this.content.removeEventListener('transitionend', this.onExpandEnd)

				// from 'none'/full height, pin an explicit start so the collapse animates
				this.content.style.maxHeight = `${this.content.scrollHeight}px`
				void this.content.offsetHeight // force reflow to commit the start value

				this.classList.remove('is-expanded')
				this.toggle.setAttribute('aria-expanded', 'false')

				requestAnimationFrame(() => {
					// clearing the inline value falls back to the CSS collapsed height
					this.content.style.maxHeight = ''
				})
			}
		}
	)
}
